export default __webpack_public_path__ + "static/media/ic_performance.8d1945e0.svg";